<template>
  <!-- 提示信息弹窗 -->
  <div class="pop">
    <div class="pop-container pop-message">
      <div class="pop-container-title">
        <div class="title-wrap">
          <div class="title-icon"></div>
          <span class="title-text">{{ $t("paygame.tip") }}</span>
        </div>
        <div class="pop-close" @click="closeModal"></div>
      </div>
      <p class="pop-container-content" v-html="message"></p>
      <div class="btns" @click="closeModal">
        <div class="btn">
          <span>{{ $t("paygame.confirm") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "",
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="scss">
</style>
